import { gql } from '@apollo/client'

export default gql`
  mutation markRead($id: ID!) {
    markRead(id: $id) {
      id
      read
    }
  }
`
